<template>
  <div id="home">
    <div class="homeWrap">
      <div class="moduleWrap" v-if="showList">
        <div class="moduleUp">
          <router-link class="linkA linkA_samll" to="/student/class_detail">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="regular/file-alt" scale="3.5"></v-icon>
              </div>
              <p>进行中的培训班</p>
            </div>
          </router-link>
          <router-link
            class="linkA linkA_samll"
            to="/student/tran_his"
            v-if="showHistory"
          >
            <div class="moduleItem classItem">
              <div class="icon">
                <v-icon name="business-time" scale="4.5"></v-icon>
              </div>
              <p>培训经历和证书</p>
            </div>
          </router-link>
          <div class="linkA linkA_big">
            <div class="moduleItem-big">
              <div class="item-wrapper-normal">
                <div class="icon" style="margin: 5px 5px 0 5px">
                  <v-icon name="chalkboard-teacher" scale="4"></v-icon>
                </div>
                <p>我的简历</p>
              </div>
              <div class="item-wrapper-hover">
                <div
                  @click="navigateToUrl('/student/basicSetting')"
                  class="item-wrapper-hover-content item-wrapper-hover-left"
                >
                  <div class="icon">
                    <v-icon name="user-edit" scale="4"></v-icon>
                  </div>
                  <p>基本信息</p>
                </div>
                <div
                  @click="navigateToUrl('/student/qualificationSetting')"
                  class="item-wrapper-hover-content item-wrapper-hover-right"
                >
                  <div class="icon">
                    <v-icon name="user-shield" scale="4"></v-icon>
                  </div>
                  <p>简历内容</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="moduleDown">
          <!--<router-link class="linkA linkA_samll" to="/expireStudent/record_qualification"  v-if="achievement_verify!=='N' && showUploadQua">-->
          <!--<div class="moduleItem">-->
          <!--<div class="icon">-->
          <!--<v-icon name="file-invoice" scale="4"></v-icon>-->
          <!--</div>-->
          <!--<p>缺失资质</p>-->
          <!--</div>-->
          <!--</router-link>-->
          <router-link  v-if="advance_admission_show" class="linkA linkA_samll" :to="{path: 'confirmPreAdmission', query: {advance_uuid: advance_admission}}">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="file-invoice" scale="4"></v-icon>
              </div>
              <p>预录取培训班</p>
            </div>
          </router-link>
          <router-link  v-if="!isFive" class="linkA linkA_samll" to="/student/education_list">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="file-invoice" scale="3.5"></v-icon>
              </div>
              <p>线上继续教育</p>
            </div>
          </router-link>
          <template v-if="!isFive">
             <router-link class="linkA linkA_samll" to="/student/getLicenseList">
                <div class="moduleItem">
                <div class="icon">
                    <v-icon name="regular/file-alt" scale="3.5"></v-icon>
                </div>
                <p>教练员执照</p>
                </div>
            </router-link>
          </template>
         
          <router-link class="linkA linkA_samll" to="/student/materials">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="user-cog" scale="4"></v-icon>
              </div>
              <p>学习资料和下载</p>
            </div>
          </router-link>
        </div>
        <div class="moduleDown" v-if="showEnroll">
          <router-link class="linkA linkA_190" to="/student/registrationList" v-if="showTrainEnroll">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="chalkboard-teacher" scale="4"></v-icon>
              </div>
              <p>等级培训和补考报名</P><P style="margin-top: 0;font-size: 20px;">（B级及以上级别）</p>
            </div>
          </router-link>
          <router-link class="linkA linkA_190" to="/student/continueList" v-if="showTrainEnroll">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="chalkboard-teacher" scale="4"></v-icon>
              </div>
              <p>继续教育培训报名</P><P style="margin-top: 0;font-size: 20px;">（C级及以上级别）</p>
            </div>
          </router-link>
          <router-link class="linkA linkA_190" :to="{path: 'registrationList', query: {enroll_list_type: 'zhuanxiang'}}" v-if="showZhuanxiangEnroll">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="chalkboard-teacher" scale="4"></v-icon>
              </div>
              <p>专项培训和补考报名 </P><P style="margin-top: 0;font-size: 20px;">（守门员/体能等）</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <el-dialog
      class="eval-dialog"
      :visible.sync="allDisabled"
      title
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="460px"
      center
    >
      <div class="to-eval">
        <div class="img">
          <img src="@/assets/images/evaluation_tips.png" alt />
        </div>
        <div class="tips">
          <p v-html="tips.title"></p>
        </div>
        <el-button type="primary" @click="gotoSetting">{{
          tips.button_text
        }}</el-button>
      </div>
    </el-dialog>
    <select-organ :organList="organList" @hideTips="hideTips" :showdialog="showSelectOrganDialog"></select-organ>
  </div>
</template>

<script>
import { isEvaluated } from "@/api/training_student/api";
import { info_view, organList } from "@/api/ab_signup/api";
import { getStuHistoryTrian } from "@/api/system_manager/api";
import { storageData } from "@/assets/js/storage";
import { questionCheck } from "@/api/survey/index";
import "vue-awesome/icons/sitemap";
import "vue-awesome/icons/clipboard-list";
import "vue-awesome/icons/users-cog";
import "vue-awesome/icons/chalkboard-teacher";
import "vue-awesome/icons/user-cog";
import "vue-awesome/icons/regular/file-alt";
import "vue-awesome/icons/check";
import "vue-awesome/icons/file-signature";
import "vue-awesome/icons/comment-alt"; // 提示气泡
import "vue-awesome/icons";
import fiveMixins from "@/minix/fiveMixins";

export default {
  name: "studentIndex",
  mixins: [fiveMixins],
  data() {
    return {
      allDisabled: false,
      showUploadQua: true,
      showHistory: false,
      showEnroll: false,
      showList: false,
      showTrainEnroll: false,
      showZhuanxiangEnroll: false,
      showSelectOrganDialog:false,
      advance_admission:"",
      advance_admission_name:"",
      advance_admission_show:false,
      enroll_choose_again_uuid:"",
      organList:[],
      achievement_verify: "",
      survey_id: "",
      isSurvey: 0,
      tips: {
        title: "",
        button_text: "",
        show_type: "",
      },
    };
  },
  components: {
    "v-icon": () => import("vue-awesome/components/Icon"),
    "select-organ" :() => import('@/components/Tips/select-organ')
  },
  created() {
    this.isEvaled();
    const userInfo = storageData.getUserInfo();
    if (userInfo.class_level !== "D" && userInfo.class_level !== "early") {
      this.showHistory = true;
    }
    if(!this.isFive){
      this.getStuList();
      if(['B','A','P','0','PRO','C'].includes(userInfo.class_level)){
        this.showZhuanxiangEnroll = true;
      }else {
        this.showTrainEnroll = true;
      }
    }else {
      this.showList = true;
    }

  },
  methods: {
    navigateToUrl(url) {
      this.$router.push({
        path: url,
      });
    },
    getStuList() {
      this.showList = false;
      getStuHistoryTrian({})
        .then(res => {
          const { result } = res.data;
          if (result.coachHistoryInfo) {
            const {coachUser} = result.coachHistoryInfo;
            let level ;
            if (coachUser) level = coachUser.coachRankType;
            if (['B','A','P','0','PRO','C'].includes(level) && !this.isFive){
              this.showEnroll=true;
            }
          }
          this.showList = true;
        })
        .catch(err => {
          console.error(err);
        });
    },
    hideTips(bool){
      if (bool){
        this.showSelectOrganDialog=false;
        this.isEvaled()
      }
    },
    isEvaled() {
      isEvaluated().then(async ({ data }) => {
        if (data.status === 0) {
                      if (Number(data.result.binding_org)===1 && data.result.class_level === 'C'){
                        this.getOrganList();
                        return
                      }
          // 判断是否有调查要填写
          try {
            const res = await questionCheck();
            const { isSurvey, question } = res.data.result;
            this.isSurvey = isSurvey;
            if (question) this.survey_id = question.survey_id;
          } catch (e) {
            console.log(e);
          }
          if(data.result.advance_admission_uuid){
            this.advance_admission_show = data.result.advance_admission_uuid!=='' ? true : false;
          }
          this.advance_admission = data.result.advance_admission_uuid;
          this.enroll_choose_again_uuid = data.result.enroll_choose_again_uuid;
          this.allDisabled =
            data.result.perfect_info === 1 ||
            Boolean(data.result.has_license) ||
            data.result.perfect_info_again === 1 ||
            data.result.has_advance_admission === 1 ||
            data.result.enroll_choose_again === 1
            this.isSurvey === 1;
          if (data.result.perfect_info === 1) {
            this.tips.title =
              "首次登录需要完善个人资料<br/>资料内容在培训结束前均可在“我的简历-->基本信息”中修改。";
            this.tips.button_text = "前往完善资料";
            this.tips.show_type = "perfect_info";
          } else if (data.result.perfect_info_again === 1) {
            if(this.isFive) {
                    this.tips.title =
              "根据中国足协社会足球部要求，需要您在简历中进一步详细完善运动经历、执教经历等信息。";
                  } else {
                    this.tips.title =
              "根据中国足协技术部要求，需要您在简历中进一步详细完善运动经历、执教经历等信息。";
                  }
            
            this.tips.button_text = "前往完善资料";
            this.tips.show_type = "perfect_info_again";
          } else if (data.result.has_license) {
            this.tips.title = "您有新的教练员执照待领取，<br/>请填写领取信息";
            this.tips.button_text = "前往填写";
            this.tips.show_type = "licenseInfo";
          } else if (this.isSurvey === 1) {
            this.tips.title = "有一份问卷调查需要您完成填写。";
            this.tips.button_text = "前往问卷调查";
            this.tips.show_type = "survey";
          }else if (data.result.has_advance_admission){
            this.tips.title="您已被预录取参加“"+data.result.advance_admission_name+"”，确认是否可以参加本期培训班？";
            this.tips.button_text="前往确定";
            this.tips.show_type="advance_admission";
          }else if (data.result.enroll_choose_again){
            this.tips.title="您需要根据“"+data.result.enroll_choose_again_name+"”内容，选择意向参加的培训班，感谢您的配合。";
            this.tips.button_text="前往选择";
            this.tips.show_type="enroll_choose_again";
          }
        }
      });
    },
    getOrganList(){
      organList({}).then(
        ({ data: { result, status } }) => {
          if (status === 0) {
            this.organList = result.list;
            this.showSelectOrganDialog=true;
          }
        }
      );
    },
    gotoSetting() {
      if (this.tips.show_type === "eva_show") {
        this.$router.push({ name: "StuCreateEvaluation" });
      } else if (this.tips.show_type === "perfect_info") {
        this.$router.push({
          path: "vita",
          query: {},
        });
      } else if (this.tips.show_type === "perfect_info_again") {
        this.$router.push({
          path: "qualificationSetting",
          query: {},
        });
      } else if (this.tips.show_type === "survey") {
        this.$router.push({
          path: "/survey/survey_index",
          query: { survey_id: this.survey_id },
        });
      }else if(this.tips.show_type === 'advance_admission'){
        this.$router.push({
          path: "confirmPreAdmission",
          query: {advance_uuid:this.advance_admission}
        });
      }else if(this.tips.show_type === 'enroll_choose_again'){
        this.$router.push({
          path: "enroll_choose_again",
          query: {signId:this.enroll_choose_again_uuid}
        });
      } else {
        this.$router.push({
          path: "getLicenseList",
          query: {},
        });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
#home
  width 100%
  height 100%
  display flex
  justify-content center
  align-items center
  user-select none
  .homeWrap
    width 930px
    .logoTitle
      height 85px
      display flex
      flex-direction column
      justify-content center
      align-items center
      margin 0 0 40px 0
      color $color_title
      font-size 40px
      font-weight bolder
      text-shadow 2px 1px 3px #231815
    .moduleWrap
      .moduleUp
        margin 40px 0
        display flex
        .linkA
          flex 1 1 auto
          margin 0 20px
        .linkA_samll
          width 195px
        .linkA_big
          width 420px
      .moduleDown
        margin 40px 0
        display flex
        .linkA
          flex 1 1 auto
          margin 0 20px
        .linkA_samll
          width 430px
      .moduleItem
        position relative
        width 100%
        height 200px
        display flex
        flex-direction column
        justify-content center
        align-items center
        color $color_white
        font-size 23px
        background-color $block_bg_color_base
        cursor pointer
        .icon
          display flex
          align-items center
        p
          margin 20px 0 0
      .moduleItem-big
        position relative
        width 100%
        height 100%
        cursor default
        .item-wrapper-normal
          width 100%
          height 200px
          display flex
          flex-direction column
          justify-content center
          align-items center
          color $color_white
          font-size 23px
          background-color $block_bg_color_base
          cursor pointer
          .icon
            display flex
            align-items center
          p
            margin 20px 0 0
        .item-wrapper-hover
          width 100%
          height 100%
          display none
          .item-wrapper-hover-content
            height 100%
            width calc(50% - 15px)
            background-color $block_bg_color_base
            color $color_white
            display flex
            flex-direction column
            justify-content center
            align-items center
            color $color_white
            font-size 23px
            cursor pointer
            .icon
              display flex
              align-items center
            p
              margin 20px 0 0
      .moduleItem-big:hover .item-wrapper-normal
        display none
      .moduleItem-big:hover .item-wrapper-hover
        display flex
        justify-content space-between
        width 100%
        height 100%
      .classItem
        .tips
          position absolute
          top calc(20% - 15px)
          right calc(35% - 15px)
          .icon
            color $color_suc
          .num
            width 100%
            height 100%
            padding 2px 0 0
            position absolute
            top 0
            left 0
            text-align center
            font-size $font_size_big
  .to-eval
    font-size 16px
    text-align center
    img
      width 100px
    .tips
      margin-bottom 15px
</style>
<style lang="stylus" >
.el-badge__content.is-dot
  height 12px
  width 12px
  padding 0
  right 0
  border-radius 50%
</style>

